import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ items, className = '' }) => {
  if (!items || !items.length) return null;

  return (
    <nav aria-label="Breadcrumb" className={`mboss-breadcrumbs mb-3 ${className}`.trim()}>
      <ol className="breadcrumb mb-0 bg-transparent p-0">
        {items.map((crumb, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={`${crumb.label}-${index}`}
              className={`breadcrumb-item${isLast ? ' active' : ''}`}
              aria-current={isLast ? 'page' : undefined}
            >
              {!isLast && crumb.to ? (
                <Link to={crumb.to}>{crumb.label}</Link>
              ) : (
                crumb.label
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string,
    })
  ),
  className: PropTypes.string,
};

export default Breadcrumbs;
